import angular from 'angular';

import EventLimitNotificationComponent from './event-limit-notification.cmpt';

export default angular
    .module('application.component.notifications.component.event-limit-notification', [])
    .component(EventLimitNotificationComponent.selector, EventLimitNotificationComponent);



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/event-limit-notification/index.js